/** Canonical API paths — keep in sync with backend (sia-app-fe contract). */

// Auth is proxied by the DO Chat API (app/routers/auth.py): each endpoint runs the
// matching Supabase grant server-side and returns Supabase's own tokens, so the
// browser needs no Supabase config baked in.
export const AUTH_LOGIN = '/api/auth/login'
export const AUTH_SIGNUP = '/api/auth/signup'
export const AUTH_REFRESH = '/api/auth/refresh'
export const AUTH_GOOGLE = '/api/auth/google'
export const AUTH_FORGOT_PASSWORD = '/api/auth/forgot-password'
export const AUTH_RESET_PASSWORD = '/api/auth/reset-password'
export const AUTH_CATALOG_EXCHANGE = '/api/auth/catalog/exchange'

export const WHOAMI = '/api/me'
export const SESSION = '/v1/session'
export const WORKSPACES = '/v1/workspaces'

export const TOOLKIT_CATALOG = '/api/toolkit/catalog'

export const CHAT_COMPLETIONS = '/api/chat/completions'
export const CHAT_STREAM = '/v1/chat/stream'
export const CHAT_RUNS = '/v1/chat/runs'
export const CONVERSATIONS = '/v1/conversations'
export const PROJECTS = '/v1/projects'
export const DOCUMENTS = '/v1/documents'
// Chat-scoped uploads. Stored once in GCS and referenced by the documents
// service, unlike DOCUMENTS which makes it keep its own copy.
export const DOCUMENTS_V2 = '/v2/documents'
export const CHAT_FILES = '/v2/file_list'
export const CHAT_ARTIFACTS = '/v2/artifacts'
export const WORKFLOWS = '/v1/workflows'
export const AUTOMATIONS = '/v1/automations'
export const SCHEDULES = '/v1/schedules'
export const TRIGGERS = '/v1/triggers'
export const SANDBOX_LISTFILES = '/v1/sandbox/listfiles'
export const VOICE_TOKEN = '/v1/voice/token'
// Composio connections. The catalogue is global; the connection routes are
// scoped to the signed-in user server-side, so no user id is ever sent.
export const INTEGRATION_TOOLKITS = '/v1/integrations/toolkits'
export const INTEGRATION_CATEGORIES = '/v1/integrations/toolkits/categories'
export const INTEGRATION_CONNECTIONS = '/v1/integrations/connections'
export const INTEGRATION_PROPOSALS = '/v1/integrations/proposals'
export const INTEGRATION_ACCESS_REVIEWS = '/v1/integrations/access-reviews'
export const USAGE_ME = '/v1/usage/me'
export const ADMIN_USAGE = '/v1/admin/usage'
export const MODELS = '/v1/models'
export const LLM_CONNECTIONS = '/v1/llm-connections'
// Artifact download URLs are minted by the backend with a signed token, so
// they are used as-is rather than built here.
export const SANDBOX_DOWNLOAD = '/v1/sandbox/download'

export const MEETING_NOTES = '/api/meeting-notes'
export const MEETING_NOTES_QUERY = '/api/meeting-notes/query'
export const MEETING_NOTES_TRANSCRIPT = '/api/meeting-notes/transcript'
